import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { TranslocoModule } from '@jsverse/transloco';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';

@Component({
  selector: 'anihis-potvrde-antibiogram',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    TranslocoModule,
  ],
  templateUrl: './potvrde-antibiogram.component.html',
  styleUrls: ['./potvrde-antibiogram.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PotvrdeAntibiogramComponent
  extends FormBaseComponent
  implements OnInit
{
  @Output() formChange = new EventEmitter<any>();

  constructor() {
    super();
    this.form = this.fb.group({
      amoksiklav: new FormControl(''),
      amikacin: new FormControl(''),
      gentamicin: new FormControl(''),
      penicilin: new FormControl(''),
      trimetoprimSulfo: new FormControl(''),
      ceftriakson: new FormControl(''),
      ciprofloksacin: new FormControl(''),
      enrofloksacin: new FormControl(''),
      doksiciklin: new FormControl(''),
      tetraciklin: new FormControl(''),
      cefaleksin: new FormControl(''),
      ampiciin: new FormControl(''),
      fungi: new FormControl(''),
      veterinarianName: new FormControl(''),
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.subs.sink = this.form.valueChanges.subscribe((v) =>
      this.formChange.emit(v),
    );
  }
}
